var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 29,
    viewBox: "0 0 38 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7019 9.9133C29.9938 3.30346 23.0934 -0.709788 16.2891 0.949439C10.9718 2.24613 7.11075 6.71053 6.71294 12.0221C2.93739 12.627 0.381415 16.0905 1.00404 19.7582C1.55753 23.0188 4.46593 25.4067 7.8677 25.3936H13.6415V23.15H7.8677C5.3167 23.15 3.24867 21.1411 3.24867 18.663C3.24867 16.1849 5.3167 14.1759 7.8677 14.1759C8.50548 14.1759 9.02245 13.6737 9.02245 13.0542C9.01668 7.47838 13.6651 2.95375 19.4049 2.94821C24.3735 2.94337 28.6506 6.35563 29.6117 11.0911C29.7066 11.5639 30.1016 11.9251 30.5933 11.9885C33.7502 12.4252 35.9449 15.2653 35.4954 18.332C35.0918 21.0858 32.6714 23.1362 29.8081 23.15H25.189V25.3936H29.8081C34.2723 25.3804 37.8804 21.8542 37.8668 17.5175C37.8555 13.9075 35.3119 10.77 31.7019 9.9133Z",
    fill: "#1290E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5951 14.5001L13.9761 18.9871L15.6043 20.5688L18.2602 18V28.7577H20.5697V18L23.2141 20.5688L24.8423 18.9871L20.2233 14.5001C19.7729 14.0651 19.0455 14.0651 18.5951 14.5001Z",
    fill: "#1290E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.abb4c6dd9be4a7c0c49ac3a3972a4757.svg";
export { ForwardRef as ReactComponent };